import {useEffect, useRef} from 'react'
import {useLocation} from 'react-router-dom';

export const usePrevUri = ()=> {
    const location = useLocation()
    const path = useRef()
    useEffect(()=> {
        path.current = location.pathname
    }, [location.pathname])
    return {
        prevPath: path.current
    }
}
